import { refs, domReady } from '../modules/utils.js';
import { matches } from '../modules/media-queries.js';

class PostsList extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#setListners();
    this.#setPostsListeners(this.refs.posts);
    if (this.refs.postsImages?.length > 0) {
      this.refs.postsImages[0].setAttribute('data-active', '');
    }
  }

  #setListners() {
    const observer = new IntersectionObserver((entries) => {
      console.log(entries);
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.#loadNewPage();
        }
      });
    });

    if (this.refs.loader) {
      observer.observe(this.refs.loader);
    }
  }

  #setPostsListeners(elements) {
    elements?.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        if (matches('sm')) return;
        const id = el.getAttribute('data-id');
        const image = this.refs.postsImages?.find(imgEl => imgEl.getAttribute('data-id') === id);
        if (image) {
          this.refs.postsImages?.forEach(imgEl => imgEl.removeAttribute('data-active'));
          image.setAttribute('data-active', '');
        }
      });
    });
  }



  #loadNewPage() {
    if (this.hasAttribute('data-is-loading')) return;
    this.setAttribute('data-is-loading', '');

    fetch(this.refs.loader.href)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('[data-ref="[posts]"]');
        const images = doc.querySelectorAll('[data-ref="[postsImages]"]');
        const loaderLink = doc.querySelector('[data-ref="loader"]');

        items.forEach(item => {
          this.refs.postsContainer.appendChild(item);
          this.refs.posts.push(item);
        });

        if (this.refs.postsImagesContainer) {
          images.forEach(image => {
            this.refs.postsImagesContainer.appendChild(image);
            this.refs.postsImages.push(image);
          });
        }

        this.#setPostsListeners(items);

        this.removeAttribute('data-is-loading');

        if (loaderLink) {
          this.refs.loader.href = loaderLink.href;
          const rect = this.refs.loader.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) {
            this.#loadNewPage();
          }
        }
        else {
          this.refs.loader.remove();
        }
      });
  }
}

customElements.define('posts-list', PostsList);
